import Mesh from 'nanogl-gltf/lib/elements/Mesh'
import Node from 'nanogl-gltf/lib/elements/Node'
import Gltf from 'nanogl-gltf/lib/Gltf'
import MeshRenderer from 'nanogl-gltf/lib/renderer/MeshRenderer'
import Bounds from 'nanogl-pbr/Bounds'

import { RenderContext } from '@/webgl/core/RenderContext'
import { IRenderable } from '@/webgl/runner/interfaces/IRenderable'

export default class MeshRendererProxy implements IRenderable {
  node: Node
  renderer: MeshRenderer

  constructor(gltf: Gltf, mesh: Mesh) {
    this.node = new Node()
    this.node.mesh = mesh
    this.renderer = new MeshRenderer(gltf, this.node)
    this.renderer.computeBounds()
  }

  preRender(dt: number): void {}

  getBounds(): Bounds {
    return this.renderer.bounds
  }

  render(context: RenderContext): void {
    this.renderer.render(context.gl, context.camera, context.mask, context.pass, context.glConfig)
  }
}
